import { render, staticRenderFns } from "./featuring-grid.vue?vue&type=template&id=c873efce&scoped=true"
import script from "./featuring-grid.vue?vue&type=script&lang=js"
export * from "./featuring-grid.vue?vue&type=script&lang=js"
import style0 from "./featuring-grid.vue?vue&type=style&index=0&id=c873efce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c873efce",
  null
  
)

export default component.exports